import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-service-style1',
  templateUrl: './service-style1.component.html',
  styleUrls: ['./service-style1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServiceStyle1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/services/service-style1/service-style1.component.ts